var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4277",
    "data-name": "Group 4277",
    transform: "translate(-361 -1050)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2806",
    "data-name": "Ellipse 2806",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(361 1050)",
    fill: "#4be59e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4274",
    "data-name": "Group 4274",
    transform: "translate(-350.949 1654.883) rotate(-90)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_417",
    "data-name": "Line 417",
    x2: 12.5,
    transform: "translate(585.133 725.449)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5178",
    "data-name": "Path 5178",
    d: "M0,0,5.018,5.017,9.9,0",
    transform: "translate(592.523 730.398) rotate(-90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUp);
export default __webpack_public_path__ + "static/media/up.a788db97ffe8d6dfd0777fdb08a4ac60.svg";
export { ForwardRef as ReactComponent };